import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { getDefaultDates } from '../utils/weekDates';
import { formatOrderDate, formatOrderTime } from '../utils/orderTime';
import './WeeksOrders.css';

const ThisWeeksOrders = () => {
  const defaults = getDefaultDates();
  const [menuTypes, setMenuTypes] = useState([]);
  const [selectedMenuType, setSelectedMenuType] = useState('');
  const [pendingStart, setPendingStart] = useState(defaults.start);
  const [pendingEnd, setPendingEnd] = useState(defaults.end);
  const [weeklyOrders, setWeeklyOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchOrders = async (start, end, menuType) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({ startDate: start, endDate: end });
      if (menuType) params.set('menuType', menuType);
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/getThisWeeksOrders?${params}`,
        { headers: authHeaders }
      );
      if (!res.ok) throw new Error('Failed to load orders');
      setWeeklyOrders(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch('https://api.reshipesbakery.com/reshipes/getMenuTypes', { headers: authHeaders })
      .then(r => r.ok ? r.json() : []).then(setMenuTypes).catch(() => {});
    fetchOrders(defaults.start, defaults.end, '');
  }, [token]);

  const handleApply = () => fetchOrders(pendingStart, pendingEnd, selectedMenuType);

  return (
    <div className="container mt-5">
      <h1>Orders</h1>

      <div className="mt-3 d-flex flex-wrap gap-3 align-items-end">
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>Menu</label>
          <select
            className="form-select form-select-sm"
            value={selectedMenuType}
            onChange={e => setSelectedMenuType(e.target.value)}
            style={{ minWidth: 160 }}
          >
            <option value="">All Menus</option>
            {menuTypes.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>From</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingStart} onChange={e => setPendingStart(e.target.value)} />
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>To</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingEnd} onChange={e => setPendingEnd(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-sm" onClick={handleApply}>Apply</button>
      </div>

      {loading && <div className="mt-4">Loading…</div>}
      {error && <div className="mt-4 text-danger">{error}</div>}

      {!loading && weeklyOrders && (
        <>
          <div className="mt-4 mb-3">
            <h4>Total Profit: ${weeklyOrders.totalAmount.toFixed(2)}</h4>
          </div>

          {weeklyOrders.orders.length === 0 ? (
            <p>No orders found for this period.</p>
          ) : (
            weeklyOrders.orders.map(order => (
              <div key={order.orderId} className="mt-4">
                <h3>Customer Name: {order.customerName}</h3>
                <p>Order Date: {formatOrderDate(order.orderDate, order.orderTime)}</p>
                <p>Order Time: {formatOrderTime(order.orderDate, order.orderTime)}</p>
                <table className="table table-striped order-items-table">
                  <thead>
                    <tr>
                      <th>Food Name</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items.map((item, index) => (
                      <tr key={index}>
                        <td>{item.size} {item.foodName}</td>
                        <td>{item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p>Comments: {order.comments}</p>
                {order.deliveryFee > 0 && (
                  <p>Delivery Fee: ${order.deliveryFee.toFixed(2)}</p>
                )}
                <h4>Total Amount: ${order.orderTotal.toFixed(2)}</h4>
              </div>
            ))
          )}
        </>
      )}
    </div>
  );
};

export default ThisWeeksOrders;
